import React, { useEffect } from 'react';
import "./style.scss"
import TokenCreate from './token-create';
import Upcoming from './upcoming';
import CompleteIdo from './complete';
import Faqs from './faqs';
import Opening from './opening';

const LaunchPad = () => {
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, []);
    
     useEffect(() => {
    document.title = "Launchpad | TinyBlock";
   }, []);

    return (
        <>
            <TokenCreate />
            <Opening />
            <Upcoming />
            <CompleteIdo />
            <Faqs />
        </>
    )
}
export default LaunchPad